import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Build id is injected at build time so each deploy produces a uniquely
// hashed bundle, defeating any stale CDN/browser cache of old asset URLs.
window.__BUILD_ID__ = process.env.REACT_APP_BUILD_ID || 'dev';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
